import {
  useEditRefrigeratorMutation,
  useGetRefrigeratorByIdMutation,
  useGetRefrigeratorLogsMutation,
  useGetRefrigeratorsMutation,
  useGetRefrigeratorTypesMutation
} from "../redux/refrigerators/refrigeratorApiSlice";
import { getErrorMessage } from "../utils/commonUtils";

export default function useRefrigerators() {
  const [getRefrigerators, { isLoading: getRefrigeratorsLoading }] = useGetRefrigeratorsMutation();
  const [getRefrigeratorById, { isLoading: getRefrigeratorByIdLoading }] = useGetRefrigeratorByIdMutation();
  const [editRefrigerator, { isLoading: editRefrigeratorLoading }] = useEditRefrigeratorMutation();
  const [getRefrigeratorTypes, { isLoading: getRefrigeratorTypesLoading }] = useGetRefrigeratorTypesMutation();
  const [getRefrigeratorLogs, { isLoading: getRefrigeratorLogsLoading }] = useGetRefrigeratorLogsMutation();

  const getRefrigeratorsAPI = async (data: any) => {
    try {
      const response = await getRefrigerators(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getRefrigeratorByIdAPI = async (data: any) => {
    try {
      const response = await getRefrigeratorById(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getRefrigeratorTypesAPI = async (data: any) => {
    try {
      const response = await getRefrigeratorTypes(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getRefrigeratorLogsAPI = async (data: any) => {
    try {
      const response = await getRefrigeratorLogs(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const editRefrigeratorAPI = async (data: any) => {
    try {
      const response = await editRefrigerator(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    getRefrigeratorsAPI,
    getRefrigeratorsLoading,
    getRefrigeratorByIdAPI,
    getRefrigeratorByIdLoading,
    editRefrigeratorAPI,
    editRefrigeratorLoading,
    getRefrigeratorTypesAPI,
    getRefrigeratorTypesLoading,
    getRefrigeratorLogsAPI,
    getRefrigeratorLogsLoading,
  };
}
